export const GENERAL = 'general';
export const NAME = 'name';
export const AFFECTED_LEVEL = 'dimension';
export const SECONDARY_AFFECTED_LEVEL = 'secondaryDimension';
export const AFFECTED_LEVEL_NAME = 'dimensionName';
export const SECONDARY_AFFECTED_LEVEL_NAME = 'secondaryDimensionName';
